package com.havn.app.features.leads.domain

import com.havn.app.features.openhouses.domain.LeadTemperature

data class Lead(
    val id: String,
    val visitorId: String? = null,
    val openHouseId: String,
    val propertyId: String,
    val fullName: String,
    val email: String? = null,
    val phone: String? = null,
    val avatarDataUrl: String? = null,
    val temperature: LeadTemperature,
    val intentScore: Int? = null,
    val notes: String? = null,
    val checkedInAt: String,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val sourceProperty: LeadPropertySource,
    val sourceOpenHouse: LeadOpenHouseSource,
    val followUps: List<LeadFollowUp> = emptyList()
) {
    val contactLine: String
        get() = listOfNotNull(phone?.takeIf { it.isNotBlank() }, email?.takeIf { it.isNotBlank() })
            .joinToString(" · ")
            .ifBlank { "No contact captured" }

    val sourceLine: String
        get() = "${sourceProperty.title} · ${sourceOpenHouse.displayTitle}"
}

data class LeadPropertySource(
    val id: String,
    val title: String,
    val address: String,
    val photoDataUrls: List<String> = emptyList()
)

data class LeadOpenHouseSource(
    val id: String,
    val title: String? = null,
    val startsAt: String,
    val endsAt: String,
    val status: String
) {
    val displayTitle: String
        get() = title?.takeIf { it.isNotBlank() } ?: "Opening"
}

data class LeadFollowUp(
    val id: String,
    val channel: String,
    val status: String,
    val dueAt: String? = null,
    val completedAt: String? = null,
    val subject: String? = null,
    val body: String? = null,
    val createdAt: String? = null
)
